import { Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const ProfitGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          'Click on the button below to go to the xVVS page. Alternatively, you can go straight to the page on your own',
        )}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Input the amount of VVS to stake, and confirm the transaction. You can stake any amount of VVS')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If the transaction is successful, you will earn EXP')}
      </Text>
    </>
  )
}
